
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import {bus} from "@/plugins/bus";
  import {IBus} from "@/interfaces/bus-actions";

  @Component({})
  export default class BarrierButton extends Vue {

    get anonymous() {
      return this.$store.state.route.query[ANONYMOUS_PAGE]
        ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE])
        : false;
    }

    async openPage() {
      bus.$emit(IBus.AppMenuAction.Close);
      if (this.anonymous) return;
      await this.$store.dispatch('openPage', {routeName: ROUTE_NAME.PAGE_BARRIERS});
    }
  }
